var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcModelTier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75471 1.50049C3.51332 1.50049 2.39263 1.50049 1.69631 2.19653C1 2.89258 1 4.01284 1 6.25337C1 8.49388 1 9.61416 1.69631 10.3102C2.39263 11.0063 3.51332 11.0063 5.75471 11.0063C7.99609 11.0063 9.1168 11.0063 9.81314 10.3102C10.5094 9.61416 10.5094 8.49388 10.5094 6.25337V6.00322",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    stroke: "#242429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.5C4.60499 8.12433 6.9706 4.97373 10.5 7.33668",
    strokeWidth: 0.75,
    stroke: "#242428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99872 1.00439V2.99761M8.99872 2.99761V5.00846M8.99872 2.99761L11.0015 2.99389M8.99872 2.99761L6.99592 3.00133",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#242428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcModelTier);
export default __webpack_public_path__ + "static/media/ic-model-tier.31a6031da21f268286db05a658ba434e.svg";
export { ForwardRef as ReactComponent };